import styled from '@emotion/styled';

export const UserCreateButtonView = styled.div`
    margin-top: 1rem;
`